<template lang="pug">
.Slider
  //因為斜度要重疊，所以要有個東西把左右包起來
  .SliderBlock(v-if="slideData.length !== 0")
    //圖文
    transition(name="fade" mode="out-in")
      .SliderLeft(
        v-for="(item, index) in slideData.slice(p,p+1)"
        :key="item.id" @mouseover.prevent="havemouse()"
        @mouseleave="nomouse()"
      )
        ImgLoader(
          :img="item.media.src"
          :style="{'--bgPos': 'center', '--default-url': 'none'}"
        )
        .SliderPrev(@click="p===0? p = slideData.length - 1 : p--")
        .SliderNext(@click="p === slideData.length - 1? p=0 : p++")
        //文字框
        a.SliderTextBlock(:href="item.link")
          .SliderTitle {{ item.title }}
          .SliderSubTitle {{ item.sub_title }}

    //影片
    .SliderRight(v-html="video_data")
  .SliderDot
    .DotItem(v-for="item in dot" :key="item" :class="{active: item==p}" @click="p=item")
</template>

<script>
import ImgLoader from './ImgLoader.vue';
export default {
  props: {
    videoUrl: {
      type: String,
      default: ""
    },
    slideData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      slide: null,
      p: 0,
    };
  },
  mounted() {
    var s = this.p;
    this.slide = setInterval(() => this.setSlide(), 8000);
  },
  computed: {
    dot() {
      if (this.slideData.length !== 0) {
        var d = [];
        for (var i = this.slideData.length - 1; i  >= 0; i--) {
          d.push(i);
        }
        return d;
      }
    },
    video_data() {
      return "<iframe width=\"100%\" height=\"100%\" src=\"" + this.videoUrl + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
    }
  },
  methods: {
    setSlide() {
      if (this.slideData.length !== 0) {
        if (this.p == this.slideData.length - 1) {
          this.p = 0;
        }
        else {
          this.p += 1;
        }
      }
    },
    havemouse() {
      clearInterval(this.slide);
    },
    nomouse() {
      this.slide = setInterval(() => this.setSlide(), 8000);
    }
  },
  beforeDestroy() {
    clearInterval(this.slide);
  },
  components: { ImgLoader }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'

.Slider
  width: 100%
  height: 45vw
  // +bb
  background: url('../assets/sliderbg.png')
  +bgcon
  background-size: 100% 100%
  background-position: center 0
  box-sizing: border-box
  padding: 2% 0 0 0
  position: relative
  +flexcolumn
  align-items: center

  .SliderBlock
    width: 95%
    height: 80%
    position: relative
    box-sizing: border-box
    // +flexcolumn
    // align-items: center

    .SliderLeft
      position: absolute
      width: 52.5%
      height: 100%
      // +bb
      clip-path: polygon(0 0, 88% 0%, 100% 100%, 0% 100%)
      left: 0
      // animation: fade 0.5s ease
      // transition: 0.3s
      &:hover
        .SliderTextBlock
          transition: 0.3s
          opacity: 1
      +ie
        width: 49.5%
      .SliderPrev
        position: absolute
        +size(40px)
        background: url('../assets/slide/prev.png')
        z-index: 9
        +bgcon
        top: 50%
        left: 2%
        margin-top: -20px
        cursor: pointer
        opacity: 0.8
        &:hover
          filter: brightness(5)
          opacity: 1

      .SliderNext
        position: absolute
        +size(40px)
        background: url('../assets/slide/next.png')
        z-index: 9
        +bgcon
        top: 50%
        right: 8%
        margin-top: -20px
        cursor: pointer
        opacity: 0.8
        &:hover
          filter: brightness(5)
          opacity: 1
      .SliderTextBlock
        position: absolute
        width: 100%
        height: 40%
        opacity: 0
        background-color: rgba(black,0.7)
        bottom: 0
        padding: 10px
        box-sizing: border-box
        transition: 0.3s
        cursor: pointer
        .SliderTitle
          width: 94%
          color: white
          font-weight: 700
          height: 50%
          font-size: 2.3vw
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +com
            font-size: 2.3vw

        .SliderSubTitle
          color: white
          height: 30%
          padding: 15px 0 0 0
          font-size: 1.8vw
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          +com
            font-size: 2vw




    .SliderRight
      position: absolute
      right: 0
      width: 52.5%
      height: 100%
      // +bb
      clip-path: polygon(0 0, 100% 0, 100% 100%, 12% 100%)
      +ie
        width: 49.5%
  .SliderDot
    position: absolute
    width: 50%
    height: 5%
    // +bb
    bottom: 11%
    left: 2.5%
    // z-index: 110
    +flexrow
    .DotItem
      +size(6%, 10%)
      +bb
      border-color: #878787
      margin-right: 1.5%
      border-radius: 20px
      cursor: pointer
      &.active
        background-color: #878787

</style>



// WEBPACK FOOTER //
// src/components/Slider.vue